import styles from "./Style.module.css";


const BookingNotes = ({
  outletNotes,
  webCustomerNotes,
  customClass,
}) => {

  return (
    <div className={`${styles.notesContainer} ${customClass}`}>
    {outletNotes && (
    <div className={`${styles.note} ${styles.bookingNote}`}>
    {outletNotes}
    </div>
    )}
    {webCustomerNotes && (
        <div className={`${styles.note} ${styles.webCustomerNote}`}>
            {webCustomerNotes}
        </div>
    )}
  </div>
  );
};

export default BookingNotes;
